import { selectApiData } from 'util/selector/apiSelector';

import { AxiosInstance } from 'axios';

import { StaticResourceModel } from './dto/StaticResource.dto';
export class StaticResourceApi {
  constructor(private client: AxiosInstance) {}

  list(): Promise<StaticResourceModel[]> {
    return this.client.get(`/api/v1/static/resource`).then(selectApiData);
  }
}
